// src/components/RatingModal.js
import React, { useState } from "react";
import "./RatingModal.css";

export default function RatingModal({ show, onClose, onSubmit, userName, userRole }) {
  const [rating, setRating] = useState(0);
  const [hoveredRating, setHoveredRating] = useState(0);
  const [feedbackMessage, setFeedbackMessage] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async () => {
    if (rating === 0) {
      alert("Please select a rating before submitting");
      return;
    }

    setSubmitting(true);
    try {
      await onSubmit(rating, feedbackMessage);
      // Reset form
      setRating(0);
      setHoveredRating(0);
      setFeedbackMessage("");
      onClose();
    } catch (error) {
      console.error("Error submitting rating:", error);
    } finally {
      setSubmitting(false);
    }
  };

  const handleClose = () => {
    setRating(0);
    setHoveredRating(0);
    setFeedbackMessage("");
    onClose();
  };

  if (!show) return null;

  return (
    <div className="rating-modal-overlay" onClick={handleClose}>
      <div className="rating-modal-content" onClick={(e) => e.stopPropagation()}>
        <button className="rating-modal-close" onClick={handleClose}>×</button>
        
        <div className="rating-modal-header">
          <h2>Rate {userName}</h2>
          <p className="rating-modal-subtitle">
            Share your experience working with this {userRole === "agency" ? "agency" : "partner"}
          </p>
        </div>

        <div className="rating-modal-body">
          {/* Star Rating */}
          <div className="rating-stars-section">
            <label className="rating-label">Your Rating *</label>
            <div className="rating-stars">
              {[1, 2, 3, 4, 5].map((star) => (
                <button
                  key={star}
                  type="button"
                  className={`star-button ${
                    star <= (hoveredRating || rating) ? "filled" : ""
                  }`}
                  onMouseEnter={() => setHoveredRating(star)}
                  onMouseLeave={() => setHoveredRating(0)}
                  onClick={() => setRating(star)}
                >
                  ⭐
                </button>
              ))}
            </div>
            {rating > 0 && (
              <p className="rating-text">
                {rating === 1 && "Poor"}
                {rating === 2 && "Fair"}
                {rating === 3 && "Good"}
                {rating === 4 && "Very Good"}
                {rating === 5 && "Excellent"}
              </p>
            )}
          </div>

          {/* Feedback Message */}
          <div className="rating-feedback-section">
            <label className="rating-label">
              Feedback (Optional)
              <span className="rating-label-hint">Help others make informed decisions</span>
            </label>
            <textarea
              className="rating-textarea"
              placeholder="Share your experience (e.g., professionalism, communication, reliability)..."
              value={feedbackMessage}
              onChange={(e) => setFeedbackMessage(e.target.value)}
              rows="5"
              maxLength="500"
            />
            <div className="rating-char-count">
              {feedbackMessage.length}/500 characters
            </div>
          </div>
        </div>

        <div className="rating-modal-footer">
          <button
            className="rating-btn-cancel"
            onClick={handleClose}
            disabled={submitting}
          >
            Cancel
          </button>
          <button
            className="rating-btn-submit"
            onClick={handleSubmit}
            disabled={submitting || rating === 0}
          >
            {submitting ? "Submitting..." : "Submit Rating"}
          </button>
        </div>
      </div>
    </div>
  );
}
